import { z } from 'zod/v4';

export const ApiErrorSchema = z.object({
  statusCode: z.number(),
  code: z.string(),
  message: z.string(),
});

const VerificationMetaSchema = z.object({
  id: z.string(),
  objectId: z.string(),
  version: z.string(),
  issueDate: z.iso.datetime(),
});

const AnswerFieldSchema = z
  .object({
    value: z.unknown(),
    verificationMeta: VerificationMetaSchema.optional(),
    timestamp: z.union([z.iso.datetime(), z.null()]).optional(),
  })
  .loose();

export type AnswerField = z.infer<typeof AnswerFieldSchema>;

export const PatchTemplateAnswerBodySchema = z.object({
  meta: z
    .object({
      source: z.object({}).loose().optional(),
    })
    .optional(),
  onBehalfOfCompanyId: z.string().min(1).max(64),
  forCompanyId: z.string().min(1).max(64),
  answer: z.record(z.string().min(1), AnswerFieldSchema),
});

export type PatchTemplateAnswerBody = z.infer<
  typeof PatchTemplateAnswerBodySchema
>;

export const PatchTemplateAnswerParamsSchema = z.object({
  templateId: z.string().min(1),
});

export type PatchTemplateAnswerParams = z.infer<
  typeof PatchTemplateAnswerParamsSchema
>;

// Admin variant: the target company comes from the URL (`id`), not the body —
// `forCompanyId`/`onBehalfOfCompanyId` would be redundant with it, so they're
// dropped rather than duplicated.
export const AdminPatchTemplateAnswerBodySchema = z.object({
  meta: z
    .object({
      source: z.object({}).loose().optional(),
    })
    .optional(),
  answer: z.record(z.string().min(1), AnswerFieldSchema),
});

export type AdminPatchTemplateAnswerBody = z.infer<
  typeof AdminPatchTemplateAnswerBodySchema
>;

export const AdminPatchTemplateAnswerParamsSchema = z.object({
  id: z.string().min(1),
  templateId: z.string().min(1),
});

export type AdminPatchTemplateAnswerParams = z.infer<
  typeof AdminPatchTemplateAnswerParamsSchema
>;
